import { RuleObject } from 'antd/lib/form';
import TranslateText from 'components/hoc/TranslateText';
import { ceskePscRegExp } from 'enums/regExp';
import React from 'react';

export const pscValidation = () => [
    // TODO
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    {
        required: true,
        message: <TranslateText>{'NEVALIDNI_POVINNA_POLOZKA'}</TranslateText>
    },
    () => ({
        validator(_rule: RuleObject, value: string) {
            if (!value || ceskePscRegExp.test(value)) return Promise.resolve();
            return Promise.reject(<TranslateText>PSC_ERROR</TranslateText>);
        }
    })
];

export default pscValidation;
